import { UserManagementService } from './../../../base/user-management/user-management.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AvpCustomAdaptor } from './../../../base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { userAdministrationRoute } from '../../../core/routing/route-names';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClientAdministrationService } from './client-administration.service';
import { Component, OnInit } from '@angular/core';
import { CommandClickEventArgs, CommandModel, GridModule, PageService, FilterService, ToolbarService, SortService, EditService } from '@syncfusion/ej2-angular-grids';
import { ClientDTO, CreateClientDTO, UpdateClientDTO } from 'src/app/base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ClientAdministraionEditFormComponent } from './client-administraion-edit-form/client-administraion-edit-form.component';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { SearchFieldComponent } from 'src/app/base/shared/search-field/search-field.component';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';

import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
  selector: 'app-client-administration',
  templateUrl: './client-administration.component.html',
  styleUrls: ['./client-administration.component.scss'],
  imports: [ClientAdministraionEditFormComponent, TranslateModule, GridModule, CheckBoxModule, ToolbarModule, TitleBarComponent, SearchFieldComponent],
  providers: [PageService, FilterService, ToolbarService, SortService, EditService]
})
export class ClientAdministrationComponent extends GridBaseComponent<any> implements OnInit {

  public customEditSettings = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    mode: 'Dialog',
    showDeleteConfirmDialog: true
  };

  constructor(private clientAdministrationService: ClientAdministrationService,
    private router: Router,
    private fb: UntypedFormBuilder,
    translateService: TranslateService,
    private spinnerService: SpinnerService,
    private userManagementService: UserManagementService) {
    super(translateService, clientAdministrationService);
    this.searchOptions = { fields: ['name', 'address', 'zip', 'city', 'email', 'customerNumber', 'vendorNumber', 'countryCode'], operator: 'startswith' };
    this.gridCommands = [{
      type: 'Edit',
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-edit e-icons'
      }
    } as CommandModel, {
      type: 'None',
      title: this.translateService.instant('i18n.domain.client-administration.overview.tooltips.add-users'),
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-user--multiple e-icons'
      }
    } as CommandModel, {
      type: 'Delete',
      title: 'Delete customer',
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-trash-can e-icons'
      }
    } as CommandModel];
  }

  public ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.clientAdministrationService, this.spinnerService),
    });
    this.isActiveColumnName = 'active';
    this.editDialogTitle = 'i18n.domain.client-administration.overview.edit-dialog-title';
    this.addDialogTitle = 'i18n.domain.client-administration.overview.tooltips.add';
  }

  public onRowDataBound(args: any) {
    if (!args.data.isLocal) {
      var button = args.row.cells[args.row.cells.length - 1].getElementsByClassName('icon-trash-can');
      if (button && button.length > 0 && button[0].parentElement) {
        button[0].parentElement.hidden = true;
      }
    }
  }

  public commandClick(args: CommandClickEventArgs) {
    if (args.commandColumn?.type === 'None') {
      this.userManagementService.selectedClient = args.rowData as ClientDTO;
      this.router.navigate([userAdministrationRoute]);
    }
    else if (args.commandColumn?.type === 'Delete') {
      if ((args.rowData as ClientDTO).isLocal) {
        super.commandClicked(args);
      }
    }
  }

  protected override addObjectCompare(addedObject: ClientDTO, rowObject: ClientDTO): boolean {
    if (this.addIndexFindColumnName) {
      return addedObject.name === rowObject.name && addedObject.address === rowObject.address && addedObject.zip === rowObject.zip;
    }
    return false;
  }

  protected initializeEditForm(data: any): void {
    let enabled = data.isLocal ?? true;
    this.gridEditForm = this.fb.group({
      id: [data.id],
      name: [{ value: data.name, disabled: !enabled }, Validators.required],
      address: [{ value: data.address, disabled: !enabled }],
      zip: [{ value: data.zip, disabled: !enabled }, Validators.maxLength(7)],
      city: [{ value: data.city, disabled: !enabled }],
      countryCode: [{ value: data.countryCode, disabled: !enabled }, [Validators.maxLength(2), Validators.minLength(2)]],
      customerNumber: [{ value: data.customerNumber, disabled: !enabled }, Validators.required],
      vendorNumber: [{ value: data.vendorNumber, disabled: !enabled }],
      active: [data.active],
    });
  }

  protected getEditDialogTitleParams(rowData): object {
    return { param: rowData.name };
  }

  protected override getDataToSave(): any {
    return this.mapToClientDTO(this.gridEditForm.getRawValue());
  }

  private mapToClientDTO(formData: any): UpdateClientDTO | CreateClientDTO {
    let dto = null;
    if (!formData.id) {
      dto = new CreateClientDTO();
    } else {
      dto = new UpdateClientDTO();
      dto.id = formData.id;
    }
    dto.name = formData.name
    dto.address = formData.address;
    dto.zip = formData.zip;
    dto.city = formData.city;
    dto.countryCode = formData.countryCode;
    dto.customerNumber = formData.customerNumber;
    dto.vendorNumber = formData.vendorNumber;
    dto.active = formData.active;
    return dto;
  }
}
